/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _join = _interopRequireDefault(require("../../../common/join"));

var _props2className = _interopRequireDefault(require("./props2className"));

var _cleanup = _interopRequireDefault(require("./cleanup"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var InovuaFlex = (0, _react.forwardRef)(function (props, ref) {
  var className = (0, _join.default)('inovua-react-toolkit-flex', (0, _props2className.default)(props));

  var allProps = _objectSpread({}, props);

  (0, _cleanup.default)(allProps);
  allProps.className = className;

  if (props.factory) {
    return props.factory(allProps);
  }

  return _react.default.createElement("div", (0, _extends2.default)({
    ref: ref
  }, allProps));
});
InovuaFlex.defaultProps = {
  row: true,
  wrap: true,
  alignItems: 'center',
  display: 'flex'
};
InovuaFlex.propTypes = {
  shouldComponentUpdate: _propTypes.default.func,
  flex: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),
  display: _propTypes.default.oneOf(['flex', 'inline-flex']),
  inline: _propTypes.default.bool,
  reverse: _propTypes.default.bool,
  row: _propTypes.default.bool,
  column: _propTypes.default.bool,
  wrap: _propTypes.default.bool,
  alignItems: _propTypes.default.string,
  alignContent: _propTypes.default.string,
  justifyContent: _propTypes.default.string
};

var _default = _react.default.memo(InovuaFlex);

exports.default = _default;